import { utilsModule } from "../utils-module";

utilsModule.factory('cacheService',[function(){
    return {
        productList:undefined,
        clientList: undefined,

        clearAllCaches:function(){
            this.productList=undefined;
            this.clientList=undefined;
        }
    }
}])